import React, { memo, useState, useCallback, useMemo, useEffect } from 'react';
import { SortBy } from 'tea-component/lib/table/addons';
import TriggerViewCard from '@gp/components/TriggerViewCard';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
// import SvgIcon from '@gp/components/Iconfont';
import MergeableTable from './components/MergeableTable';
import BarAndLineEchart from './components/BarAndLineEchart';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import {
  toFirstUpperCase,
  getDownLoadCSVResponseHeaderFileName,
  downloadFileByBlob,
  stream2Object,
} from '@gp/utils/common';
import {
  fetchStudioOverallFinanceForecastCardData,
  studioOverallFinanceForecastCardDownLoad,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { useRequest } from 'ahooks';
import {
  DOWNLOAD_LOG_MAP,
  DEFAULT_SORTS,
  BASE_SCENARIO,
  CONSERVATIVE_SCENARIO,
} from './constants';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CardBtn from '@/pages/globalpedia/components/CardBtn';
import { formatStudioValues } from '@gp/pages/StudioDashboard/StudioOverall/utils';

interface ScenarioCardPropsType {
  selectBO: string[];
  selectValue: {
    type: 'market' | 'region';
    regions: string[];
    markets: string[];
  };
  filterBOLoading: boolean;
  setIsScenarioCardAllNoData: React.Dispatch<
    React.SetStateAction<boolean>
  > | null;
  setUpdateTime: React.Dispatch<React.SetStateAction<string>> | null;
}
type HandleCardType = 'base_scenario' | 'conservative_scenario' | '';
interface SortsType extends SortBy {
  handleCard: HandleCardType; // 操作的哪个卡片，和后端接口参数对应
}

const DEFAULT_PROPS: ScenarioCardPropsType = {
  selectBO: [],
  selectValue: {
    type: 'region',
    regions: [],
    markets: [],
  },
  filterBOLoading: false,
  setIsScenarioCardAllNoData: null,
  setUpdateTime: null,
};

function ScenarioCard(props: ScenarioCardPropsType) {
  const {
    selectBO,
    selectValue,
    filterBOLoading,
    setIsScenarioCardAllNoData,
    setUpdateTime,
  } = props;

  const [isInit, setIsInit] = useState<boolean>(true);
  const [doubleCardLoading, setDoubleCardLoading] = useState<boolean>(false);
  const [toDownload, setToDownload] = useState<any>(null);
  // 操作的哪个卡片，和后端接口参数对应
  const [handleCard, setHandleCard] = useState<HandleCardType>('');
  const [sorts, setSorts] = useState<SortsType>(DEFAULT_SORTS); // 这个排序记录用于后端传参
  const [baseSorts, setBaseSorts] = useState<SortsType>(DEFAULT_SORTS); // 这个排序记录base卡片
  const [conservativeSorts, setConservativeSorts] =
    useState<SortsType>(DEFAULT_SORTS); // 这个排序用于记录conservative卡片
  const [baseScenarioList, setBaseScenarioList] =
    useState<IStudioOverallFinanceForecastCardResultItem>(null);
  // const [conservativeScenarioList, setConservativeScenarioList] = useState<IStudioOverallFinanceForecastCardResultItem>(null);

  // 卡片数据
  const {
    loading: cardListLoading,
    data: cardListData,
    run: runCardList,
  } = useRequest(fetchStudioOverallFinanceForecastCardData, {
    manual: true,
    onFinally: () => {
      setDoubleCardLoading(false);
    },
  });

  // 卡片下载
  const {
    loading: downloadLoading,
    data: downloadData,
    run: runDownload,
  } = useRequest(studioOverallFinanceForecastCardDownLoad, { manual: true });

  const reset = useCallback(() => {
    setHandleCard('');
    setSorts(DEFAULT_SORTS);
    setBaseSorts(DEFAULT_SORTS);
    setConservativeSorts(DEFAULT_SORTS);
  }, []);

  const handleBaseScenarioDownload = useCallback((payload: any) => {
    setHandleCard(BASE_SCENARIO);
    setToDownload({
      downloadTime: Date?.now(),
      downloadCard: BASE_SCENARIO, // 与后端的字段值对应
      payload,
    });
  }, []);

  /* const handleConservativeScenarioDownload = useCallback((payload: any) => {
    setHandleCard(CONSERVATIVE_SCENARIO);
    setToDownload({
      downloadTime: Date?.now(),
      downloadCard: CONSERVATIVE_SCENARIO, // 与后端的字段值对应
      payload,
    });
  }, []); */

  const baseScenarioTabs = useMemo(() => {
    return [
      {
        id: 'chart-bar',
        label: <CardBtn onClick={() => {}} type="column-chart" />,
        component: <BarAndLineEchart data={baseScenarioList || []} />,
      },
      {
        id: 'table',
        label: (
          <CardBtn onClick={() => {}} type="sheet" />
        ),
        component: (
          <MergeableTable
            cardType="base_scenario" // 用于设置setHandleCard
            setHandleCard={setHandleCard}
            sorts={baseSorts}
            setSorts={setBaseSorts}
            loading={cardListLoading && handleCard === BASE_SCENARIO}
            data={baseScenarioList || []}
          />
        ),
      },
      {
        id: 'download',
        label: (
          <GeneralDownloadBtn
            uiType="2"
            fileTypes={FILE_TYPES2}
            isLoading={downloadLoading && handleCard === BASE_SCENARIO}
            onConfirm={handleBaseScenarioDownload}
          />
        ),
        component: null,
      },
    ];
  }, [
    downloadLoading,
    baseSorts,
    cardListLoading,
    handleCard,
    baseScenarioList,
  ]);

  /* const conservativeScenarioTabs = useMemo(() => {
    return [
      {
        id: 'chart-bar',
        label: (<label onClick={() => {}}><SvgIcon type="chart-column" className="svgicon" /></label>),
        component: (<BarAndLineEchart data={conservativeScenarioList || []} />),
      },
      {
        id: 'table',
        label: (<label onClick={() => {}}><SvgIcon type="chart-table" className="svgicon" /></label>),
        component: (
          <MergeableTable
            cardType="conservative_scenario" // 用于设置setHandleCard
            setHandleCard={setHandleCard}
            sorts={conservativeSorts}
            setSorts={setConservativeSorts}
            loading={cardListLoading && handleCard === CONSERVATIVE_SCENARIO}
            data={conservativeScenarioList || []}
          />
        ),
      },
      {
        id: 'download',
        label: (
          <GeneralDownloadBtn
            uiType="2"
            fileTypes={FILE_TYPES2}
            isLoading={downloadLoading && handleCard === CONSERVATIVE_SCENARIO}
            onConfirm={handleConservativeScenarioDownload}
          />
        ),
        component: null,
      },
    ];
  }, [
    downloadLoading,
    conservativeSorts,
    cardListLoading,
    handleCard,
    conservativeScenarioList,
  ]); */

  const isNoDataOfBaseScenario = useMemo(() => {
    const data = cardListData?.base_scenario;
    return (
      !data || (Array.isArray(data) && !data?.length) || !Array.isArray(data)
    );
  }, [cardListData]);

  /* const isNoDataOfConservativeScenario = useMemo(() => {
    const data = cardListData?.conservative_scenario;
    return !data || (Array.isArray(data) && !data?.length) || !Array.isArray(data);
  }, [cardListData]); */

  // 两个卡片是否都没数据，告知下面的列表，列表首行粘性定位需要改变容器高度
  useEffect(() => {
    setIsScenarioCardAllNoData?.(
      isNoDataOfBaseScenario /* && isNoDataOfConservativeScenario */,
    );
  }, [isNoDataOfBaseScenario /* isNoDataOfConservativeScenario */]);

  // 同步排序参数
  useEffect(() => {
    if (handleCard === BASE_SCENARIO) {
      setSorts(baseSorts);
    } else if (handleCard === CONSERVATIVE_SCENARIO) {
      setSorts(conservativeSorts);
    } else {
      setSorts(DEFAULT_SORTS);
    }
  }, [baseSorts, conservativeSorts, handleCard]);

  // 请求卡片数据
  useEffect(() => {
    if (isInit) {
      setIsInit(false);
      return;
    }
    if (doubleCardLoading) return;
    runCardList({
      management_team: selectBO,
      data_types: formatStudioValues(selectValue),
      order_data: sorts?.handleCard, // 哪一个卡片
      order: sorts?.order || '',
      order_metric: toFirstUpperCase(sorts?.by) || '',
    });
  }, [sorts?.order, sorts?.by, sorts?.handleCard]);
  useEffect(() => {
    reset();
    setDoubleCardLoading(true);
    runCardList({
      management_team: selectBO,
      data_types: formatStudioValues(selectValue),
      order_data: '', // 哪一个卡片
      order: sorts?.order || '',
      order_metric: toFirstUpperCase(sorts?.by) || '',
    });
  }, [selectBO, selectValue]);

  // 设置每个卡片的数据
  useEffect(() => {
    if (cardListLoading) return;
    setUpdateTime?.(cardListData?.update_time || '');
    if (handleCard === BASE_SCENARIO) {
      setBaseScenarioList(cardListData?.base_scenario || []);
    } else if (handleCard === CONSERVATIVE_SCENARIO) {
      // setConservativeScenarioList(cardListData?.conservative_scenario || []);
    } else {
      setBaseScenarioList(cardListData?.base_scenario || []);
      // setConservativeScenarioList(cardListData?.conservative_scenario || []);
    }
  }, [cardListLoading]);

  // 下载
  useEffect(() => {
    if (toDownload?.downloadTime) {
      runDownload({
        management_team: selectBO,
        data_types: formatStudioValues(selectValue),
        file_type: toDownload?.payload?.fileType === FILE_TYPES_MAP.CSV ? 1 : 2,
        order_data: toDownload?.downloadCard || '', // 哪一个卡片
        order:
          (toDownload?.downloadCard === BASE_SCENARIO
            ? baseSorts?.order
            : conservativeSorts?.order) || '',
        order_metric:
          toFirstUpperCase(
            toDownload?.downloadCard === BASE_SCENARIO
              ? baseSorts?.by
              : conservativeSorts?.by,
          ) || '',
      });
    }
  }, [toDownload?.downloadTime]);

  // 抛出下载后的文件
  const throwDownLoadResult = async () => {
    try {
      // 拿到响应头中的文件名称
      const fileName = getDownLoadCSVResponseHeaderFileName(
        downloadData?.headers,
      );
      downloadFileByBlob(downloadData?.data, fileName);
      const logKey =
        ALL_REPORT_OPERATION_LOG?.[
          DOWNLOAD_LOG_MAP?.[
            toDownload?.payload?.fileType + '_' + toDownload?.downloadCard
          ]
        ];
      logKey && reportOperationLog(logKey, 'button');
    } catch (err: any) {
      const resData = await stream2Object(err?.data);
      throw new Error(resData?.msg || '');
    }
  };
  // 下载结果
  useEffect(() => {
    if (downloadLoading || !downloadData) return;
    throwDownLoadResult();
  }, [downloadLoading]);

  return (
    <div className="dbg-studio-overall-finance-year-forecast-scenario-card-area">
      <TriggerViewCard
        className="dbg-studio-overall-finance-year-forecast-scenario-card-item"
        title="Base Scenario"
        loading={filterBOLoading || doubleCardLoading}
        isNoData={isNoDataOfBaseScenario}
        tabs={baseScenarioTabs}
        defaultActiveId="chart-bar"
      />
      {/* <TriggerViewCard
        className="dbg-studio-overall-finance-year-forecast-scenario-card-item"
        title="Conservative Scenario"
        loading={filterBOLoading || doubleCardLoading}
        isNoData={isNoDataOfConservativeScenario}
        tabs={conservativeScenarioTabs}
        defaultActiveId="chart-bar"
      /> */}
    </div>
  );
}

ScenarioCard.defaultProps = DEFAULT_PROPS;

export default memo(ScenarioCard);
